<div class="file-details-page">
  <!-- Header with back navigation -->
  <header class="page-header">
    <div class="header-left">
      <button class="back-btn" (click)="goBack()">
        <span class="back-icon">&larr;</span>
        Back to Requests
      </button>
      <h1>File Details</h1>
    </div>

    <!-- Action Buttons -->
    @if (file$ | async; as file) {
      <div class="action-buttons">
        <ukg-button
          *appHasPermission="[Permissions.AccessToFileDetailsToolbar]"
          variant="primary"
          [attr.disabled]="
            (isUpdating$ | async) || statusControl.value === file.fileStatusId
              ? ''
              : null
          "
          (click)="onSave(file)"
          (keydown.enter)="onSave(file)">
          {{ (isUpdating$ | async) ? 'Saving...' : 'Save Status' }}
        </ukg-button>
      </div>
    }
  </header>

  <!-- Loading state -->
  @if (isLoading$ | async) {
    <div class="loading-container">
      <ukg-progress-circular></ukg-progress-circular>
      <p>Loading file details...</p>
    </div>
  }

  <!-- Error state -->
  @if (error$ | async; as error) {
    <div class="error-container">
      <div class="error-message">
        <span class="error-icon">!</span>
        <p>{{ error }}</p>
      </div>
      <button class="back-link" (click)="goBack()">Return to Requests</button>
    </div>
  }

  <!-- Content -->
  @if (file$ | async; as file) {
    <!-- File Details Section -->
    <section class="file-section">
      <h2>File Information</h2>
      <form class="details-form">
        <!-- File ID (Read-only) -->
        <div class="form-field read-only">
          <span class="field-label" id="fileIdLabel">File ID</span>
          <span class="field-value" aria-labelledby="fileIdLabel">{{
            file.id
          }}</span>
        </div>
        <!-- Request ID (Read-only) -->
        <div class="form-field read-only">
          <span class="field-label" id="requestIdLabel">Request ID</span>
          <span class="field-value" aria-labelledby="requestIdLabel">{{
            file.requestId
          }}</span>
        </div>
        <!-- Total Documents (Read-only) -->
        <div class="form-field read-only">
          <span class="field-label" id="totalDocsLabel">Total Documents</span>
          <span class="field-value" aria-labelledby="totalDocsLabel">{{
            file.totalDocuments
          }}</span>
        </div>
        <!-- File Status (Editable) -->
        <div
          class="form-field"
          *appHasPermission="[Permissions.AccessToChangeFileStatus]">
          <label for="fileStatus">File Status</label>
          <select id="fileStatus" [formControl]="statusControl">
            <option [ngValue]="null">-- Select Status --</option>
            @for (status of statuses$ | async; track status) {
              <option [ngValue]="status.id">
                {{ status.fileStatus }}
              </option>
            }
          </select>
        </div>
        <!-- File Status - Read Only -->
        <div
          class="form-field read-only"
          *appHasPermission="
            [Permissions.AccessToChangeFileStatus];
            inverse: true
          ">
          <span class="field-label">File Status</span>
          @for (status of statuses$ | async; track status) {
            @if (status.id === file.fileStatusId) {
              <span class="field-value">
                {{ status.fileStatus }}
              </span>
            }
          }
        </div>
        <!-- File Name (Read-only, Full Width) -->
        <div class="form-field read-only full-width">
          <span class="field-label" id="fileNameLabel">File Name</span>
          <span
            class="field-value file-name-value"
            aria-labelledby="fileNameLabel"
            >{{ file.fileName }}</span
          >
        </div>
      </form>
    </section>
  }
</div>
